import { render, staticRenderFns } from "./caijixiangqingNew.vue?vue&type=template&id=4622bdc0&scoped=true"
import script from "./caijixiangqingNew.vue?vue&type=script&lang=js"
export * from "./caijixiangqingNew.vue?vue&type=script&lang=js"
import style0 from "./caijixiangqingNew.vue?vue&type=style&index=0&id=4622bdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622bdc0",
  null
  
)

export default component.exports